import React from "react";
import PropTypes from "prop-types";
import { findAnswer } from "../../state/questionStates";
import { isMobile, isTablet, isIOS, isAndroid } from "react-device-detect";
import { has, get, isEmpty } from 'lodash';
import util from 'util';

const QuestionLabel = ({ question = {}, store = {} }) => {
    let label = question.questionLabel;
    let className = "w3-panel w3-opacity" + (has(question, "class") ? " " + question.class : " w3-large w3-center");

    if (has(question, "desktopQuestionLabel") && !isMobile && !isTablet && !isIOS && !isAndroid) {
        label = get(question, "desktopQuestionLabel");
    }

    let count = ((label && label.match(/%s/g)) || []).length;
    if (count > 0 && has(question, "questionLabelProperties") && !isEmpty(question.questionLabelProperties)) {
        let state = store.getState();
        let values = [];
        for (let i = 0; i < count; i++) {
            if (question.questionLabelProperties[i].indexOf(".") !== -1) {
                let parts = question.questionLabelProperties[i].split(".");
                let answer = findAnswer(state, parts[0], parts[1]);
                values.push(get(answer, "value", ""));
            }
            else {
                values.push("");
            }
        }
        label = util.format(label, ...values);
    }

    return <div id={question.questionID} className={className} dangerouslySetInnerHTML={{__html: label}}></div>
    //return (
    //    <div id={question.questionID} className="w3-panel w3-large w3-center w3-opacity">{label}</div>
    //);
};

QuestionLabel.propTypes = {
    question: PropTypes.object
};

QuestionLabel.contextTypes = {
    store: PropTypes.object
};

export default QuestionLabel;
